const TranslationService = {
    get: () => {
        return window.ZigTranslations;
    },
};
export default TranslationService;
